// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__7z4EX","inputDescription":"styles_inputDescription__mYReP"};